import React, { Component } from 'react'
import TrippleButton from './buttons/TrippleButton'
import Question from './comments/Question'
import Poll from './comments/Poll'
import { connect } from 'react-redux'
import { Auth } from '../../../helpers'
import { socketSendMessage, switchEditAnswerPopup, switchAnswerToQuestionPopup, switchAdminAnswerEditPopup, switchAddPoll } from '../../../actions'
import './QandAPolls.css'

class QandAPolls extends Component {
  constructor (props) {
    super(props)

    this.state = {
      message: '',
      answered: this.props.answered,
      polls: this.props.polls,
      questions: this.props.questions
    }
  }

  scrollToBottom () {
    const { scroll } = this.refs
    if (scroll) {
      scroll.scrollTop = scroll.scrollHeight - scroll.clientHeight
    }
  }

  componentWillReceiveProps (props, state) {
    if (this.state.questions !== props.questions) {
      let isLengthChanged = this.state.questions.length < props.questions.length
      // console.log('Is length changed::', isLengthChanged)
      this.setState({ questions: props.questions }, () => {
        let lastOne = this.state.questions[this.state.questions.length - 1]
        if (lastOne && lastOne.participant._id === Auth.getParticipant() && isLengthChanged) {
          this.scrollToBottom()
        }
      })
    }
    if (this.state.polls !== props.polls) {
      this.setState({ polls: props.polls })
    }
    if (this.state.answered !== props.answered) {
      this.setState({ answered: props.answered })
    }
  }

  renderContent () {
    if (this.props.activeTab === 'Q&A') {
      return this.renderQuestions()
    }
    if (this.props.activeTab === 'POLLS') {
      return this.renderPolls()
    }
    if (this.props.activeTab === 'ANSWERED') {
      return this.renderAnswered()
    }
  }

  checkIfLiked (likes) {
    let checker = false
    if (likes) {
      checker = likes.filter(l => l.participant === Auth.getParticipant()).length > 0
    }
    return checker
  }

  renderQuestions () {
    return (
      <div className='polls-container'>
        <div className='polls-inner-container'>
          {
            this.state.questions.map((q, key) => {
              return (
                <Question
                  key={key}
                  activeLike={this.checkIfLiked(q.likes)}
                  details={q}
                  onEdit={() => {
                    this.props.dispatch(switchEditAnswerPopup(q))
                  }}
                  onAnswer={() => {
                    this.props.dispatch(switchAnswerToQuestionPopup(q))
                  }}
                  onLikeChange={(isLiked) => {
                    this.props.dispatch(socketSendMessage({ action: 'new-comment-like', data: { id: q._id } }))
                  }}
                />
              )
            })
          }
        </div>
      </div>
    )
  }

  renderPolls () {
    return (
      <div className='polls-container'>
        <div className='polls-inner-container'>
          {
            this.state.polls.map((p, key) =>
              <Poll
                key={key}
                details={p}
                activeLike={this.checkIfLiked(p.likes)}
                onEdit={() => this.props.dispatch(switchAddPoll(p))}
                onLikeChange={(isLiked) => {
                  this.props.dispatch(socketSendMessage({ action: 'new-comment-like', data: { id: p._id } }))
                }}
                onAnswerChange={answer => {
                  this.props.dispatch(socketSendMessage({ action: 'new-comment-voteanswer', data: { id: p._id, answer } }))
                }}
              />
            )
          }
        </div>
        {/* {Auth.isAdmin() &&
          <div className='plus-button'>
            <span onClick={() => this.props.dispatch(switchAddPoll())}>+</span>
          </div>
        } */}
      </div>
    )
  }

  renderAnswered () {
    return (
      <div className='polls-container'>
        <div className='polls-inner-container'>
          {
            this.state.answered.map((q, key) =>
              <Question
                key={key}
                answer
                details={q}
                activeTab={this.props.activeTab}
                activeLike={this.checkIfLiked(q.likes)}
                onAnswerEdit={(answer) => {
                  q = { ...q, answer }
                  this.props.dispatch(switchAdminAnswerEditPopup(q))
                }}
                onLikeChange={(isLiked) => {
                  this.props.dispatch(socketSendMessage({ action: 'new-comment-like', data: { id: q._id } }))
                }}
                onAnswer={() => {
                  this.props.dispatch(switchAnswerToQuestionPopup(q))
                }}
              />
            )
          }
        </div>
      </div>
    )
  }

  sendMessage (ev) {
    if (ev) {
      ev.preventDefault()
    }
    this.props.dispatch(socketSendMessage({ action: 'new-comment-qapolls', data: { text: this.state.message } }))
    this.setState({ message: '' })
  }

  disableRenderTextArea () {
    let screenDisplay = (this.props.activeTab === 'Q&A')
    // console.log(isAdmin, );
    return !(screenDisplay)
  }

  disableRenderAddPollButton () {
    let screenDisplay = this.props.activeTab === 'POLLS' && Auth.isAdmin()
    return !screenDisplay
  }

  checkButtonsArea (event) {
    if (event.which === 13 && !event.shiftKey && !this.state.displaySuggestions) {
      event.preventDefault()
      this.sendMessage()
    }
  }

  handleAreaChange (event) {
    this.setState({ message: event.target.value })
  }

  renderTextArea () {
    if (this.disableRenderTextArea()) return null
    return (
      <div className='chat-message'>
        <div>
          <form name='chat-message' onSubmit={this.sendMessage}>
            <textarea
              placeholder='Type your question'
              className='chat-message'
              value={this.state.message}
              onKeyDown={this.checkButtonsArea.bind(this)}
              onChange={this.handleAreaChange.bind(this)}
            />
            <div className='bttn' style={{ background: 'none' }}>
              <button
                className='chat-message-send'
                onClick={this.sendMessage.bind(this)}><img alt='' src='/imgs/icon-chat-send.png' /></button>
            </div>
          </form>
        </div>
      </div>
    )
  }

  renderAddPollButton () {
    if (this.disableRenderAddPollButton()) return null
    return (
      <div className='chat-message'>
        <div
          onClick={() => this.props.dispatch(switchAddPoll())}
          className='plus-button'>
          <span>+</span>CREATE POLL
        </div>
      </div>
    )
  }

  setDynamicHeight () {
    if (this.disableRenderTextArea()) {
      return {
        height: '100%'
      }
    }
    return {}
  }

  addBackgroundImage () {
    if (this.props.activeTab === 'Q&A' && this.state.questions.length > 0) return false
    if (this.props.activeTab === 'POLLS' && this.state.polls.length > 0) return false
    if (this.props.activeTab === 'ANSWERED' && this.state.answered.length > 0) return false
    return true
  }

  render () {
    return (
      <div className='qapolls-wrap'>
        <div
          className='qapolls-inner'
          style={{ height: `${(this.disableRenderTextArea() && this.disableRenderAddPollButton()) ? 'calc(100% - 30px)' : 'calc(100% - 95px)'}` }}>
          <TrippleButton
            activeTab={this.props.activeTab}
            onChangeTab={(tab) => {
              this.props.dispatch({ type: 'comments/activeTab', tab: tab })
            }} />
          <div
            className={`comments-wrap ${this.addBackgroundImage() ? 'no-content-bg' : ''} ${this.props.activeTab === 'ANSWERED' ? 'answered-wrap' : ''}`}
            ref={'scroll'}>
            {this.renderContent()}
          </div>
        </div>
        {this.renderTextArea()}
        {this.renderAddPollButton()}
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  activeTab: state.comments.activeTab,
  answered: state.comments.answered,
  polls: state.comments.polls,
  questions: state.comments.questions
})

export default connect(mapStateToProps)(QandAPolls)



// WEBPACK FOOTER //
// ./src/screens/dashboard/chat/QandAPolls.js